<template>
  <pie-chart :height="250" ref="bigChart" :chart-data="bigBarChart.chartData"
    :extra-options="bigBarChart.extraOptions"></pie-chart>
</template>

<script>
import * as chartConfigs from "@/components/Charts/config";
import PieChart from "@/components/Charts/PieChart";

export default {
  name: 'PieChart',
  data() {
    return {
      loading: false,
      bigBarChart: {
        chartData: {
          datasets: [{
            label: 'My First Dataset',
            data: [65, 59, 80, 81, 56, 55, 40],
            fill: false,
            borderColor: 'rgb(75, 192, 192)',
            tension: 0.1
          }],
          labels: ['SEDEX', 'DDD']
        },
        extraOptions: chartConfigs.blueChartOptions,
      },
    };
  },
  components: {
    PieChart,
  },
}
</script>
